import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { format } from 'date-fns'
import { bg } from 'date-fns/locale';
import jsonExcel from '../node_modules/vue-json-to-excel'
import Snotify from 'vue-snotify'
import cloneDeep from 'lodash.clonedeep';
import './assets/styles/main.scss'

Vue.config.productionTip = false;

Date.prototype.GetFirstDayOfWeek = function () {
  return new Date(this.setDate(this.getDate() - this.getDay() + (this.getDay() == 0 ? -6 : 1)));
}
Date.prototype.GetLastDayOfWeek = function () {
  return new Date(this.setDate(this.getDate() - (this.getDay() == 0 ? 7 : this.getDay()) + 7));
}

Vue.prototype.$http = axios;
Vue.prototype.$cloneDeep = cloneDeep;

// Object.defineProperty(Vue.prototype, '$_', { value: _ });

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.filter('formatDate', function (value) {
  if (value) {
    return format(new Date(value), 'dd/MM/yyyy')
  }
})

Vue.filter('formatFullDate', function (value) {
  if (value) {
    return format(new Date(value), 'dd/MM/yyyy - HH:mm:ss')
  }
})

Vue.filter('formatDay', function (value) {
  if (value) {
    return format(new Date(value), 'd MMMM', { locale: bg });
  }
})

Vue.filter('formatDayOfWeek', function (value) {
  if (value) {
    return format(new Date(value), 'EEEE', { locale: bg });
  }
})

Vue.filter('formatDayYear', function (value) {
  if (value) {
    return format(new Date(value), 'd MMMM yyyy', { locale: bg });
  }
})

Vue.filter('getMonth', function (value) {
  if (value) {
    let month = format(new Date(value), 'MMMM', { locale: bg });
    return month[0].toUpperCase() + month.slice(1);
  }
})

const options = {
  toast: {
    timeout: 5000,
    showProgressBar: false
  }
}
Vue.use(Snotify, options)

// VUE COMPONENTS
Vue.component('downloadExcel', jsonExcel);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')